import { useState } from "react";
import { TransitionFadeIn } from "../../../core/transitions/fade_in";

export type CollectionsGridNoItemsProps = {
    caption?: string;
};

export function CollectionsGridNoItems({caption = "No products found matching this filter."}:CollectionsGridNoItemsProps)
{    
    return (
        <>
            <TransitionFadeIn>
                <div className="container">
                    <div className="icon">
                        <i className="icon-collection-empty" />
                    </div>
                    <div className="text">
                        {caption}
                    </div>
                </div>
            </TransitionFadeIn>
            <style jsx>{`
            .container {
                width: 100%;
                display: flex;
                flex-direction: column;
                align-items: center;
                color: #424242;
            }

            .icon {
                font-size: 150rem;
                margin-top: 30rem;
                margin-bottom: 15rem;
                color: #787878;
            }

            .text {
                font-size: 18rem;
                text-align: center;
            }
           `}</style>
        </>
    );
}